import React from 'react';
import BookingStart from './BookingStart';
import BookingProcess from './BookingProcess';
import GuestDetails from './GuestDetails';
// import styles from '../css/DatePicker.css';
const App = ({bookingStartInfo}) => {
    return (<BookingStart bookingStartInfo={bookingStartInfo}></BookingStart>);
    // switch(BookingProcess.step) {
    //     case 1:
    //     case 2:
    //         return (<GuestDetails></GuestDetails>);
    //     default:
    //       // code block
    //   }
}
export default App;